module.exports = __webpack_public_path__ + "static/media/GWSPWN.cd91c37d.jpg";